export const mobileMenu = () => {
  $('.menu-toggle').click(function (e) {
    e.stopPropagation();
    $(this).toggleClass('is-active');
    // toggle body class of menu shown
    $('body').toggleClass('menu-shown');
  });
};
